const defaultNumberFormatterOptions = {
  emptyValue: "n.a",
  assetClassFormats: {
    default: { maximumFractionDigits: 2, minimumFractionDigits: 2 },
    stock: { maximumFractionDigits: 2, minimumFractionDigits: 2 },
    currency: { maximumFractionDigits: 4, minimumFractionDigits: 4 },
    fund: { maximumFractionDigits: 2, minimumFractionDigits: 2 },
    bond: { maximumFractionDigits: 2, minimumFractionDigits: 2 }
  },
  typeFormats: {
    price: {},
    volume: { maximumFractionDigits: 3, minimumFractionDigits: 0, notation: "compact", compactDisplay: "short" },
    performanceAbs: { signDisplay: "always" },
    performancePct: { style: "percent", signDisplay: "always" },
    absolutePercentage: { style: "percent" },
    integer: { minimumIntegerDigits: 1, maximumFractionDigits: 0, minimumFractionDigits: 0 }
  }
};

export { defaultNumberFormatterOptions };
